import { typedAction } from "../helpers";
import { SET_IS_SAVING_IN_BACKGROUND, SET_IS_BUSY_SAVING, SET_IS_CHECKING_DUPLICATES, SET_NEEDS_REDIRECT_TO_HOME, SET_IS_LOADING_METADATA } from "./actionTypes";
import { savingInBackgroundState, ISavingInBackgroundInfo } from "../models/reduxModels";

// One empty list, so panels that follow the messages don't re-run their effects for nothing.
const NO_MESSAGES: string[] = [];

const initialState: savingInBackgroundState = {
  type: null,
  isSavingInBackground: false,
  isBusySaving: false,
  isSuccess: true,
  isCheckingForDuplicates: false,
  needsRedirectToHome: false,
  errorMessages: NO_MESSAGES,
  isLoadingMetadata: false
};

export const setIsSavingInBackground = (isSavingInBackground: boolean, type?: string) => {
  return typedAction(SET_IS_SAVING_IN_BACKGROUND, { isSavingInBackground: isSavingInBackground, type: type });
};

export const setIsBusySaving = (isBusySaving: ISavingInBackgroundInfo) => {
  return typedAction(SET_IS_BUSY_SAVING, isBusySaving);
};

export const setIsCheckingForDuplicates = (isCheckingForDuplicates: boolean) => {
  return typedAction(SET_IS_CHECKING_DUPLICATES, isCheckingForDuplicates);
};

export const setIsBusyLoadingMetadata = (isLoadingMetadata: boolean) => {
  return typedAction(SET_IS_LOADING_METADATA, isLoadingMetadata);
};

export const setNeedsRedirectToHome = (needsRedirectToHome: boolean) => {
  return typedAction(SET_NEEDS_REDIRECT_TO_HOME, needsRedirectToHome);
};

type SavingInBackgroundAction = ReturnType<
  typeof setIsSavingInBackground
  | typeof setIsBusySaving
  | typeof setIsCheckingForDuplicates
  | typeof setIsBusyLoadingMetadata
  | typeof setNeedsRedirectToHome>;

// A failed API call's response body can arrive as the messages (App.tsx): text, an error page or an
// object.
const asMessages = (errorMessages: unknown): string[] =>
  Array.isArray(errorMessages) ? errorMessages
    : typeof errorMessages === "string" && errorMessages && !/^\s*</.test(errorMessages) ? [errorMessages]
      : NO_MESSAGES;

export function savingInBackgroundReducer(
  state = initialState,
  action: SavingInBackgroundAction
): savingInBackgroundState {
  switch (action.type) {
    case SET_IS_SAVING_IN_BACKGROUND:
      return { ...state, type: action.payload.type, isSavingInBackground: action.payload.isSavingInBackground, isCheckingForDuplicates: false, errorMessages: NO_MESSAGES };
    case SET_IS_BUSY_SAVING:
      return { ...state, isBusySaving: action.payload.isBusySaving, isSuccess: action.payload.isSuccess, isCheckingForDuplicates: false, errorMessages: asMessages(action.payload.errorMessages) };
    case SET_IS_CHECKING_DUPLICATES:
      return { ...state, isCheckingForDuplicates: action.payload };
    case SET_IS_LOADING_METADATA:
      return { ...state, isLoadingMetadata: action.payload };
    case SET_NEEDS_REDIRECT_TO_HOME:
      return { ...state, needsRedirectToHome: action.payload };
    default:
      return state;
  }
}
